import Tsv from 'js/utils/tsv';

/**
 * tsv data base
 */
export default class DB extends Tsv {
  /**
   * constructor
   */
  constructor() {
    super();

    // tables
    // schema{type: text('web' or 'visit')}
    this.app = {type: process.env.APP_TYPE};

    // schema{id: number, name: string}
    this.phase = [
      {id: 1, name: '習慣化フェーズ'},
      {id: 2, name: 'シーン訴求フェーズ'},
      {id: 3, name: 'カテゴリ認知フェーズ'},
      {id: 4, name: '立ち上げフェーズ'},
    ];

    // schema{id: number, type: app.type, phaseId: phase.id, range: number}
    this.ranges = [
      {id: 1, type: 'web', phaseId: 1, range: 15},
      {id: 2, type: 'web', phaseId: 2, range: 10},
      {id: 3, type: 'web', phaseId: 3, range: 5},
      {id: 4, type: 'web', phaseId: 4, range: 0},
      {id: 5, type: 'visit', phaseId: 1, range: 30},
      {id: 6, type: 'visit', phaseId: 2, range: 20},
      {id: 7, type: 'visit', phaseId: 3, range: 10},
      {id: 8, type: 'visit', phaseId: 4, range: 0},
    ];

    // schema{id: number, weight: number, name: string}
    this.categorys = [
      {id: 1, weight: 30, name: '現状分析力'},
      {id: 2, weight: 20, name: 'ファクト開発力'},
      {id: 3, weight: 10, name: 'ニュース素材化力'},
      {id: 4, weight: 0, name: '情報発信力'},
    ];

    // schema{min: number, max: number}
    this.radarchart = {
      min: 0,
      max: 0,
    };

    // schema{blockRange: number}
    this.linechart = {
      blockRange: 0,
    };

    // schema{
    //   id: number,
    //   categoryId: categorys.id,
    //   text: string,
    //   checked: string
    // }
    this.questions = [];
  }

  /**
   * select
   * @param {object} param
   * @return {object}
   */
  select(param) {
    let result = {};
    const table = this[param.table];
    for (let i = 0, l = table.length; i < l; i++) {
      if (table[i][param.where] == param.value) {
        result = table[i];
        break;
      }
    }

    return result;
  }

  /**
   * import tsv data
   * @param {string} data
   */
  import(data) {
    const lines = this.splitLine(data);
    let columnCount = 0;

    lines.forEach((line, index) => {
      // タブで分解
      const columns = this.splitColumn(line);

      // tsvヘッダーを除外
      if (0 == index) {
        columnCount = columns.length;
        return;
      }

      // 配列ではない、想定した列数じゃない場合は取り込み対象外
      if (!Array.isArray(columns) || columnCount != columns.length) {
        return;
      }

      // 取り込み
      const category = this.divideIntoCategoryIdAndName(columns[0]);
      this.insertQuestionsTable(index, category, columns);
    });

    // レーダーチャート設定
    this.insertRadarchart();

    // 線グラフ設定
    this.insertLinechart();
  }

  /**
   * divide into category id and name
   * @param {string} text
   * @return {object}
   */
  divideIntoCategoryIdAndName(text) {
    const data = text.split('-');
    return {
      id: Number(data[0]),
      name: data[1],
    };
  }

  /**
   * insert question
   * @param {number} id
   * @param {object} category
   * @param {array} data
   */
  insertQuestionsTable(id, category, data) {
    // アプリタイプが web かつ、 質問が web で非表示の場合
    // または、非表示フラグが立っている場合は取り込まない
    if (
      ('web' == this.app.type && 'TRUE' != data[1]) ||
      ('TRUE' == (data[3] || ''))
    ) {
      return;
    }

    this.questions.push({
      id: id,
      categoryId: category.id,
      text: data[2] || '',
      checked: '',
    });
  }

  /**
   * insert radar chart
   */
  insertRadarchart() {
    // 先頭カテゴリと一致する質問を取得
    const categoryQuestions = this.questions.filter((q) => {
      return (this.categorys[0].id == q.categoryId);
    });

    this.radarchart.min = 0;
    this.radarchart.max = categoryQuestions.length;
  }

  /**
   * insert line chart
   */
  insertLinechart() {
    const phase = this.selectAllPhaseJoinRangesOrderByRangeDesc();
    const range = phase[0].range - phase[1].range;

    this.linechart.blockRange = range;
  }

  /**
   * update questions.checked
   * @param {object} param
   */
  updateQuestionChecked(param) {
    const ids = this.questions.map((item) => {
      return item.id;
    });
    const index = ids.indexOf(Number(param.id));
    if (-1 == index) {
      return;
    }

    this.questions[index].checked = param.checked;
  }

  /**
   * select all phase join ranges
   * @return {array}
   */
  selectAllPhaseJoinRangesOrderByRangeDesc() {
    const phase = this.phase.map((item, index) => {
      for (let i = 0, l = this.ranges.length; i < l; i++) {
        if (
          item.id == this.ranges[i].phaseId &&
          this.app.type == this.ranges[i].type
        ) {
          item.range = this.ranges[i].range;
          break;
        } else {
          continue;
        }
      }

      return item;
    });

    phase.sort((a, b) => {
      if (a.range > b.range) {
        return -1;
      }

      if (a.range < b.range) {
        return 1;
      }

      return 0;
    });

    return phase;
  }
}



// WEBPACK FOOTER //
// ./src/js/stores/app/db.js